import { SortResult, SortedDocs } from './types';
import { PilotDoc } from '../../../types';
import { sortDocsByDate } from '../../../libs/sortDocsByDate';

export function getTheLatestDocAsGood(docs: PilotDoc[]): SortResult {
  const processedDocs: SortedDocs = {
    good: [],
    needAttention: [],
  };

  // if there is no document of type, just stop. Pilot doesn't need to upload the document of type
  if (docs.length === 0) {
    return processedDocs;
  }

  // If there are documents, show the pilot only the latest one, always as good even if expired
  const sortedByEndDateDocs = sortDocsByDate(docs);
  const theLatestExpiringDoc = sortedByEndDateDocs[0];

  processedDocs.good.push(theLatestExpiringDoc);

  return processedDocs;
}
